<div class="hw-box-content">
  <div class="hw-header-wrap">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-6">Utility Setup</div>
          <div class="col-6 text-right">
            <fn-button class="fn-button btn btn-primary btn-null btn-sm btn-round mr-5" [type]="'primary'"
              btnClass="btn-sm btn-round" [text]="'Reload Schema'" (click)="reload()"></fn-button>
            <fn-button [type]="'info'" btnClass="btn-sm btn-round" [text]="'Save'" (click)="saveData()"></fn-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="hw-content">
    <!-- <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 headerSetting">
          <div class="box-content">
            <h4 class="tileHeading">AUTH SERVER DETAIL:</h4>
            <div class="row">
              <div class="col-6 wrapper_content">
                <div class="row">
                  <div class="col-5">
                    <label class="control-label text-left"
                      >Enable Delete Old History</label
                    >
                  </div>
                  <div class="col-7">
                    <fn-switch name="enableDeleteOldHistory"></fn-switch>
                  </div>
                </div>
              </div>
              <div class="col-6 wrapper_content">
                <div class="row">
                  <div class="col-5">
                    <label class="control-label text-left"
                      >OffSet Days To Delete Timer Task</label
                    >
                  </div>
                  <div class="col-7">
                    <fn-base-input
                      name="offSetToDeleteTimerTask"
                      [dataKey]="'offSetToDeleteTimerTask'"
                      [type]="'text'"
                      [fnInputValidator]
                    ></fn-base-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 wrapper_content">
                <div class="row">
                  <div class="col-5">
                    <label class="control-label text-left"
                      >OffSet Days To Delete Timer Task</label
                    >
                  </div>
                  <div class="col-7">
                    <fn-base-input
                      name="offSetToDeleteTimerTask"
                      [dataKey]="'offSetToDeleteTimerTask'"
                      [type]="'text'"
                      [fnInputValidator]
                    ></fn-base-input>
                  </div>
                </div>
              </div>
              <div class="col-6 wrapper_content">
                <div class="row">
                  <div class="col-5">
                    <label class="control-label text-left"
                      >OffSet Days To Delete Timer Task</label
                    >
                  </div>
                  <div class="col-7">
                    <fn-base-input
                      name="offSetToDeleteTimerTask"
                      [dataKey]="'offSetToDeleteTimerTask'"
                      [type]="'text'"
                      [fnInputValidator]
                    ></fn-base-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 headerSetting">
          <div class="box-content">
            <h4 class="tileHeading">CET EventIDs:</h4>
            <div class="row">
              <div class="col-6 wrapper_content">
                <div class="row">
                  <div class="col-5">
                    <label class="control-label text-left">LogIn Event</label>
                  </div>
                  <div class="col-7">
                    <fn-base-input
                      name="offSetToDeleteTimerTask"
                      [dataKey]="'offSetToDeleteTimerTask'"
                      [type]="'text'"
                      [fnInputValidator]
                    ></fn-base-input>
                  </div>
                </div>
              </div>
              <div class="col-6 wrapper_content">
                <div class="row">
                  <div class="col-5">
                    <label class="control-label text-left"
                      >Graph Color Change Limit</label
                    >
                  </div>
                  <div class="col-7">
                    <fn-base-input
                      name="offSetToDeleteTimerTask"
                      [dataKey]="'offSetToDeleteTimerTask'"
                      [type]="'text'"
                      [fnInputValidator]
                    ></fn-base-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-12 text-right">
                    <fn-button
                      [type]="'info'"
                      btnClass="btn-sm btn-round"
                      [iconAddonBefore]="'global-add'"
                      [text]="'Add'"
                      (click)="addCET()"
                    ></fn-button>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-5">
                        <label>Severity</label>
                      </div>
                      <div class="col-5">
                        <label>Telegram Group</label>
                      </div>
                      <div class="col-2">
                        <label>Actions</label>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix space-5"></div>
                  <div *ngFor="let telegram of telegramList; let i = index">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-5">
                          <fn-base-input
                            class="width-350px"
                            name="severity"
                            [(ngModel)]="telegram.severity"
                            [dataKey]="'severity'"
                            [type]="'text'"
                            [fnInputValidator]
                            required
                          ></fn-base-input>
                        </div>
                        <div class="col-5">
                          <fn-base-input
                            class="width-400px"
                            name="telegramGrp"
                            [(ngModel)]="telegram.group"
                            [dataKey]="'telegramGrp'"
                            [type]="'text'"
                            [fnInputValidator]
                            required
                          ></fn-base-input>
                        </div>
                        <div class="col-2">
                          <button
                            class="btn btn-sm btn-danger fn-global-delete ms-2"
                            (click)="deleteCETRow()"
                          ></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-12 text-right">
                    <fn-button
                      [type]="'info'"
                      btnClass="btn-sm btn-round"
                      [iconAddonBefore]="'global-add'"
                      [text]="'Add'"
                      (click)="addCET()"
                    ></fn-button>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-5">
                        <label>Severity</label>
                      </div>
                      <div class="col-5">
                        <label>Telegram Group</label>
                      </div>
                      <div class="col-2">
                        <label>Actions</label>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix space-5"></div>
                  <div *ngFor="let telegram of telegramList; let i = index">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-5">
                          <fn-base-input
                            class="width-350px"
                            name="severity"
                            [(ngModel)]="telegram.severity"
                            [dataKey]="'severity'"
                            [type]="'text'"
                            [fnInputValidator]
                            required
                          ></fn-base-input>
                        </div>
                        <div class="col-5">
                          <fn-base-input
                            class="width-400px"
                            name="telegramGrp"
                            [(ngModel)]="telegram.group"
                            [dataKey]="'telegramGrp'"
                            [type]="'text'"
                            [fnInputValidator]
                            required
                          ></fn-base-input>
                        </div>
                        <div class="col-2">
                          <button
                            class="btn btn-sm btn-danger fn-global-delete ms-2"
                            (click)="deleteCETRow()"
                          ></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 headerSetting">
          <div class="box-content">
            <h4 class="tileHeading">Telegram Info</h4>
            <div class="row">
              <div class="setup-scroll" alta-nice-scroll style="max-height: calc(100vh - 800px); overflow-y: auto">
                <div class="col-12">
                  <div class="row">
                    <div class="col-6">Add Severity Wise Telegram Group</div>
                    <div class="col-6 text-right">
                      <fn-button [type]="'info'" btnClass="btn-sm btn-round" [iconAddonBefore]="'global-add'"
                        [text]="'Add'" (click)="addGroup()"></fn-button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-5">
                          <label>Severity</label>
                        </div>
                        <div class="col-5">
                          <label>Telegram Group</label>
                        </div>
                        <div class="col-2">
                          <label>Actions</label>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix space-5"></div>
                    <div *ngFor="let telegram of objectHash.telegramgroupList; let i = index">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-5">
                            <fn-base-input class="width-350px" name="severity" [(ngModel)]="telegram.severity"
                              [dataKey]="'severity'" [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-5">
                            <fn-base-input class="width-400px" name="telegramGrp" [(ngModel)]="telegram.group"
                              [dataKey]="'telegramGrp'" [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-2">
                            <button class="btn btn-sm btn-danger fn-global-delete ms-2" (click)="deleteRow(i)"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 headerSetting">
          <div class="box-content">
            <h4 class="tileHeading">CET EventIDs:</h4>
            <div class="row">
              <div class="setup-scroll" alta-nice-scroll style="max-height: calc(100vh - 730px); overflow-y: auto">
                <div class="col-12">
                  <div class="row">
                    <div class="col-6"></div>
                    <div class="col-6 text-right">
                      <fn-button [type]="'info'" btnClass="btn-sm btn-round" [iconAddonBefore]="'global-add'"
                        [text]="'Add'" (click)="addEventIds()"></fn-button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-5">
                          <label>EeventIDs</label>
                        </div>
                        <div class="col-5">
                          <label>Friendly Name</label>
                        </div>
                        <div class="col-2">
                          <label>Actions</label>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix space-5"></div>
                    <div *ngFor="let eventId of objectHash.eventIdList; let i = index">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-5">
                            <fn-base-input class="width-350px" name="name" [(ngModel)]="eventId.name" [dataKey]="'name'"
                              [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-5">
                            <fn-base-input class="width-400px" name="friendlyName" [(ngModel)]="eventId.friendlyName"
                              [dataKey]="'friendlyName'" [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-2">
                            <button class="btn btn-sm btn-danger fn-global-delete ms-2"
                              (click)="deleteEvent(i)"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 headerSetting">
          <div class="box-content">
            <h4 class="tileHeading">CET Host EventIDs:</h4>
            <div class="row">
              <div class="setup-scroll" alta-nice-scroll style="max-height: calc(100vh - 730px); overflow-y: auto">
                <div class="col-12">
                  <div class="row">
                    <div class="col-6"></div>
                    <div class="col-6 text-right">
                      <fn-button [type]="'info'" btnClass="btn-sm btn-round" [iconAddonBefore]="'global-add'"
                        [text]="'Add'" (click)="addHostEventIds()"></fn-button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-5">
                          <label>EeventIDs</label>
                        </div>
                        <div class="col-5">
                          <label>Friendly Name</label>
                        </div>
                        <div class="col-2">
                          <label>Actions</label>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix space-5"></div>
                    <div *ngFor="let eventId of objectHash.eventIdsForHost; let i = index">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-5">
                            <fn-base-input class="width-350px" name="name" [(ngModel)]="eventId.name" [dataKey]="'name'"
                              [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-5">
                            <fn-base-input class="width-400px" name="friendlyName" [(ngModel)]="eventId.friendlyName"
                              [dataKey]="'friendlyName'" [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-2">
                            <button class="btn btn-sm btn-danger fn-global-delete ms-2"
                              (click)="deleteHostEvent(i)"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 headerSetting">
          <div class="box-content">
            <h4 class="tileHeading">Alert DashBoard Url:</h4>
            <div class="row">
              <div class="setup-scroll" alta-nice-scroll style="max-height: calc(100vh - 730px); overflow-y: auto">
                <div class="col-12">
                  <div class="row">
                    <div class="col-6">Add DashBoard Environment And Url</div>
                    <div class="col-6 text-right">
                      <fn-button [type]="'info'" btnClass="btn-sm btn-round" [iconAddonBefore]="'global-add'"
                        [text]="'Add'" (click)="addEnvList()"></fn-button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-5">
                          <label>Environment Name</label>
                        </div>
                        <div class="col-5">
                          <label>Environment URL</label>
                        </div>
                        <div class="col-2">
                          <label>Actions</label>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix space-5"></div>
                    <div *ngFor="let envList of objectHash.allEnvList; let i = index">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-5">
                            <fn-base-input class="width-350px" name="name" [(ngModel)]="envList.name" [dataKey]="'name'"
                              [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-5">
                            <fn-base-input class="width-400px" name="Url" [(ngModel)]="envList.url" [dataKey]="'Url'"
                              [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-2">
                            <button class="btn btn-sm btn-danger fn-global-delete ms-2"
                              (click)="deleteEnvList(i)"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 headerSetting">
          <div class="box-content">
            <h4 class="tileHeading">SLT Config:</h4>
            <div class="row">
              <div class="setup-scroll" alta-nice-scroll style="max-height: calc(100vh - 730px); overflow-y: auto">
                <div class="col-12">
                  <div class="row">
                    <div class="col-6">Add Slt Config</div>
                    <div class="col-6 text-right">
                      <fn-button [type]="'info'" btnClass="btn-sm btn-round" [iconAddonBefore]="'global-add'"
                        [text]="'Add'" (click)="addSltList()"></fn-button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-5">
                          <label>Severity</label>
                        </div>
                        <div class="col-5">
                          <label>Hours</label>
                        </div>
                        <div class="col-2">
                          <label>Actions</label>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix space-5"></div>
                    <div *ngFor="let envList of objectHash.sltList; let i = index">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-5">
                            <fn-base-input class="width-350px" name="sev" [(ngModel)]="envList.sev" [dataKey]="'sev'"
                              [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-5">
                            <fn-base-input class="width-400px" name="hour" [(ngModel)]="envList.hour" [dataKey]="'hour'"
                              [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-2">
                            <button class="btn btn-sm btn-danger fn-global-delete ms-2"
                              (click)="deleteSltList(i)"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 headerSetting">
    <div class="box-content">
      <h4 class="tileHeading">Queries</h4>
      <div class="row">
        <div class="col-12 wrapper_content">
          <div class="row">
            <div class="col-4">
              <label class="control-label text-left">Clock Query</label>
            </div>
            <div class="col-8">
              <fn-base-input name="offlineCLockQuery_pg" [(ngModel)]="objectHash.offlineCLockQuery_pg" [dataKey]="'offlineCLockQuery_pg'"
                [type]="'text'" [fnInputValidator]></fn-base-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 wrapper_content">
          <div class="row">
            <div class="col-4">
              <label class="control-label text-left">Site Query</label>
            </div>
            <div class="col-8">
              <fn-base-input name="siteOfflineClkQuery_pg" [(ngModel)]="objectHash.siteOfflineClkQuery_pg" [dataKey]="'siteOfflineClkQuery_pg'"
                [type]="'text'" [fnInputValidator]></fn-base-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 wrapper_content">
          <div class="row">
            <div class="col-4">
              <label class="control-label text-left">App Query</label>
            </div>
            <div class="col-8">
              <fn-base-input name="appStartupQuery_pg" [(ngModel)]="objectHash.appStartupQuery_pg" [dataKey]="'appStartupQuery_pg'"
                [type]="'text'" [fnInputValidator]></fn-base-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
      </div>
    </div>

    <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 headerSetting">
          <div class="box-content">
            <h4 class="tileHeading">Schema IDs:</h4>
            <div class="row">
              <div class="setup-scroll" alta-nice-scroll style="max-height: calc(100vh - 730px); overflow-y: auto">
                <div class="col-12">
                  <div class="row">
                    <div class="col-6"></div>
                    <div class="col-6 text-right">
                      <fn-button [type]="'info'" btnClass="btn-sm btn-round" [iconAddonBefore]="'global-add'"
                        [text]="'Add'" (click)="addSchema()"></fn-button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-5">
                          <label>SchemaID</label>
                        </div>
                        <div class="col-5">
                          <label>Friendly Name</label>
                        </div>
                        <div class="col-2">
                          <label>Actions</label>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix space-5"></div>
                    <div *ngFor="let schema of objectHash.schemaList; let i = index">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-5">
                            <fn-base-input class="width-350px" name="name" [(ngModel)]="schema.name" [dataKey]="'name'"
                              [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-5">
                            <fn-base-input class="width-350px" name="name" [(ngModel)]="schema.friendlyName"
                              [dataKey]="'friendlyName'" [type]="'text'" [fnInputValidator] required></fn-base-input>

                          </div>
                          <div class="col-2">
                            <button class="btn btn-sm btn-danger fn-global-delete ms-2"
                              (click)="deleteSchema(i)"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-8 offset-2">
      <div class="row">
        <div class="col-12 headerSetting">
          <div class="box-content">
            <h4 class="tileHeading">Clock/Site Schema IDs:</h4>
            <div class="row">
              <div class="setup-scroll" alta-nice-scroll style="max-height: calc(100vh - 730px); overflow-y: auto">
                <div class="col-12">
                  <div class="row">
                    <div class="col-6"></div>
                    <div class="col-6 text-right">
                      <fn-button [type]="'info'" btnClass="btn-sm btn-round" [iconAddonBefore]="'global-add'"
                        [text]="'Add'" (click)="addClockSchema()"></fn-button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-5">
                          <label>SchemaID</label>
                        </div>
                        <div class="col-5">
                          <label>Friendly Name</label>
                        </div>
                        <div class="col-2">
                          <label>Actions</label>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix space-5"></div>
                    <div *ngFor="let schema of objectHash.clocksiteSchema; let i = index">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-5">
                            <fn-base-input class="width-350px" name="name" [(ngModel)]="schema.name" [dataKey]="'name'"
                              [type]="'text'" [fnInputValidator] required></fn-base-input>
                          </div>
                          <div class="col-5">
                            <fn-base-input class="width-350px" name="name" [(ngModel)]="schema.friendlyName"
                              [dataKey]="'friendlyName'" [type]="'text'" [fnInputValidator] required></fn-base-input>

                          </div>
                          <div class="col-2">
                            <button class="btn btn-sm btn-danger fn-global-delete ms-2"
                              (click)="deleteClockSchema(i)"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
